import React from 'react'
import {
    FaSitemap,
    FaUser,
    FaSimCard,
    FaTasks,
    FaHome,
    FaBimobject,
    FaFileImage,
    FaUserCog,
    FaCog,
    FaProjectDiagram,
    FaInbox
} from 'react-icons/fa'
import { IoMdCalendar } from 'react-icons/io'

import { type } from '../../../constants/QBActionsConst'

const options = [
    {
        key: 'dashboard',
        label: 'sidebar.dashboard',
        leftIcon: <FaHome size={20} style={{ marginRight: 20 }} />,
        allow: [type.ALL],
    },
    {
        key: 'message',
        label: 'sidebar.message',
        leftIcon: <FaInbox size={20} style={{ marginRight: 20 }} />,
        allow: [type.ALL],
    },
    {
        leftIcon: <FaTasks size={20} style={{ marginRight: 20 }} />,
        key: 'qbtask',
        label: 'sidebar.task',
        allow: [type.ALL],
    },
    {
        leftIcon: <FaSimCard size={20} style={{ marginRight: 20 }} />,
        key: 'qbreport',
        label: 'sidebar.qbreport',
        allow: [type.REPORT_VIEW, type.ALL],
    },
    {
        key: "basic-data",
        label: "sidebar.basic_data",
        leftIcon: <FaProjectDiagram size={20} style={{ marginRight: 20 }} />,
        allow: [type.OBJECT_VIEW, type.EVENT_VIEW, type.MEDIA_VIEW],
        children: [
            {
                leftIcon: <FaBimobject size={20} style={{ marginRight: 20 }} />,
                key: 'qbobjects',
                label: 'sidebar.qbobjects',
                allow: [type.OBJECT_VIEW],
            },
            {
                leftIcon: <IoMdCalendar size={20} style={{ marginRight: 20 }} />,
                key: 'qbevents',
                label: 'sidebar.qbevents',
                allow: [type.EVENT_VIEW],
            },
            {
                leftIcon: <FaFileImage size={20} style={{ marginRight: 20 }} />,
                key: 'qbmedias',
                label: 'sidebar.qbmedia',
                allow: [type.MEDIA_VIEW],
            },
        ]
    },
    {
        key: "setting",
        label: 'sidebar.setting',
        leftIcon: <FaCog size={20} style={{ marginRight: 20 }} />,
        allow: [type.ONLY_SUPER_ADMIN, type.USER_VIEW, type.ORGANIZATION_VIEW],
        children: [
            {
                leftIcon: <FaUserCog size={20} style={{ marginRight: 20 }} />,
                key: 'qbrole',
                label: 'sidebar.role',
                allow: [type.ONLY_SUPER_ADMIN]
            },
            {
                leftIcon: <FaUser size={20} style={{ marginRight: 20 }} />,
                key: 'users',
                label: 'sidebar.user',
                allow: [type.USER_VIEW],
            },
            {
                leftIcon: <FaSitemap size={20} style={{ marginRight: 20 }} />,
                key: 'organization-management',
                label: 'sidebar.organization',
                allow: [type.ORGANIZATION_VIEW],
            },
        ]
    }
]
export default options
